<template>
  <el-row :gutter="24" type="flex" align="middle" class="cci-item ta-c">
    <el-col :span="2">
      <el-checkbox :label="item.id" />
    </el-col>
    <el-col :span="5" class="fio">
      {{ item.fio }}<br />
      {{ item.phone }}
    </el-col>
    <el-col :span="3" class="status">
      <b>
        {{ getStatus(item.status) }}
      </b>
    </el-col>
    <el-col :span="8" class="ta-l">
      {{ item.description }}
    </el-col>
    <el-col :span="3" class="info">
      <el-row>
        <el-col :span="14" class="ta-r">
          <p>Дозвон:</p>
          <p class="red">Недозвон:</p>
        </el-col>
        <el-col :span="10" class="ta-l ml-10">
          <p>{{ stats.yes }}</p>
          <p class="red">{{ stats.no }}</p>
        </el-col>
      </el-row>
    </el-col>
    <action-buttons contacts @call="onCall" @info="onInfo" />
  </el-row>
</template>

<script>
import { contactStatuses } from '@/views/CallCenter/constants'
import ActionButtons from '@/views/CallCenter/components/ActionButtons'

export default {
  name: 'CCIItem',
  components: { ActionButtons },
  props: {
    item: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      contactStatuses,
    }
  },
  computed: {
    stats() {
      const stats = { yes: 0, no: 0 }

      this.item.calls.map(c => (c.status === '1' ? stats.yes++ : stats.no++))

      return stats
    },
  },
  methods: {
    getStatus(status) {
      return status ? contactStatuses[status] : 'Нет данных'
    },
    onCall() {
      this.$emit('set', 'callModal', this.item.id)
    },
    onInfo() {
      this.$emit('set', 'statsModal', this.item.id)
    },
  },
}
</script>

<style lang="sass">
.cci-item
  min-height: 80px
  background: #fff
  margin-top: 20px
  font-size: 14px
  padding: 15px 0
  .el-checkbox__label
    display: none
  .fio
    font-size: 18px
  .status
    color: #FFB800
  .info
    p
      font-weight: bold
      margin: 0
      line-height: 24px
      &.red
        color: #ff0000
    .ml-10
      padding-left: 10px
</style>
